export const DICT = {
  en: {
    // Brand
    "brand.tagline_hero": "Two hearts,\none seamless workspace.",
    "brand.tagline_sub": "Plan every detail of your wedding together — from Akad to Reception — in one calm, beautiful place.",
    // Login
    "auth.first_login_title": "Create your own password",
    "auth.first_login_desc": "Your account was created by your partner using a temporary password. For security, please create your own password now.",
    "auth.new_password": "New password",
    "auth.confirm_new_password": "Confirm new password",
    "auth.first_login_mismatch": "Passwords do not match",
    "auth.password_too_short": "Password must be at least 6 characters",
    "auth.first_login_success": "Password created! Please log in with your new password.",
    "login.welcome": "Welcome, lovebirds.",
    "login.license_note": "One license = one wedding workspace shared by two partners.",
    // Language toggle
    "lang.label": "Language",
    // Common
    "common.save": "Save",
    "common.saving": "Saving…",
    "common.cancel": "Cancel",
    "common.delete": "Delete",
    "common.copy": "Copy",
    "common.copied": "Copied!",
    "common.name": "Name",
    "common.category": "Category",
    "common.date": "Date",
    "common.status": "Status",
    "common.notes": "Notes",
    "common.phone": "Phone",
    "common.email": "Email",
    // Nav
    "nav.dashboard": "Dashboard",
    "nav.couple_talk": "Couple Talk",
    "nav.moodboard": "Wedding Moodboard",
    "nav.more": "More",
    "nav.checklist": "Checklist",
    "checklist.section": "Preparation",
    "checklist.title": "Checklist",
    "nav.budget": "Budget",
    "nav.savings": "Savings",
    "nav.guests": "Guests",
    "nav.vendors": "Vendors",
    "nav.timeline": "Timeline",
    "nav.documents": "Documents",
    "nav.ai": "Weddly AI",
    "nav.settings": "Settings",
    "nav.admin": "Admin",
    "nav.logout": "Log out",
    "nav.group.main": "Main Menu",
    "nav.group.planning": "Planning",
    "nav.collapse": "Minimize menu",
    "nav.expand": "Expand menu",
    // Documents
    "docs.section": "Checklist",
    "docs.title": "Marriage Documents",
    "docs.subtitle": "Complete paperwork for KUA / church & civil registration — with optional file storage.",
    "docs.stat_total": "Total items",
    "docs.stat_done": "Collected",
    "docs.stat_uploaded": "Files stored",
    "docs.add_title": "Add your own document",
    "docs.name_ph": "e.g. Passport",
    "docs.optional": "optional",
    "docs.add_btn": "Add",
    "docs.hint": "Templates are provided automatically. Tick an item once you have it, and upload the file so everything stays in one place.",
    "docs.mark_done": "Mark as collected",
    "docs.no_file_hint": "Optional: upload the file so you don't have to search for it later.",
    "docs.upload": "Upload",
    "docs.replace_file": "Replace",
    "docs.remove_file": "Remove file",
    "docs.empty": "No documents yet.",
    "docs.confirm_delete": "Delete this document from the list?",
    "docs.file_too_large": "File is too large (max 8 MB)",
    "docs.load_error": "Failed to load documents",
    "docs.name_required": "Document name is required",
    "docs.added": "Document added ✅",
    "docs.add_error": "Failed to add document",
    "docs.update_error": "Failed to update document",
    "docs.deleted": "Document deleted",
    "docs.delete_error": "Failed to delete document",
    "docs.uploaded": "File uploaded ✅",
    "docs.upload_error": "Failed to upload file",
    "docs.file_removed": "File removed",
    // Setup wizard
    "setup.step": "Step",
    "setup.of": "of",
    "setup.saving": "Saving…",
    "setup.draft_saved": "Draft saved",
    "setup.back": "Back",
    "setup.next": "Next",
    "setup.finish": "Launch Weddly workspace",
    "setup.finishing": "Launching…",
    "setup.ready_toast": "Your wedding plan is ready!",
    "setup.step1_title": "Who is getting married?",
    "setup.step1_sub": "Tell us the couple's names. You can invite your partner later.",
    "setup.p1_full": "Partner 1 full name",
    "setup.p1_nick": "Nickname",
    "setup.p2_full": "Partner 2 full name",
    "setup.p2_nick": "Nickname",
    "setup.step2_title": "When is your big day?",
    "setup.step2_sub": "Pick a date — even a target one. You can change it anytime.",
    "setup.date_confirmed": "Confirmed date",
    "setup.date_target": "Target date",
    "setup.date_undecided": "Not decided",
    "setup.date_confirmed_hint": "We know the date",
    "setup.date_target_hint": "Approximate date",
    "setup.date_undecided_hint": "Skip for now",
    "setup.wedding_date": "Wedding date",
    "setup.step3_title": "Where's the celebration?",
    "setup.step3_sub": "Country and city help us tailor recommendations.",
    "setup.country": "Country",
    "setup.city": "City",
    "setup.venue_mode": "Venue mode",
    "setup.venue_same": "Same venue",
    "setup.venue_diff": "Different venues",
    "setup.venue_undecided": "Not decided",
    "setup.step4_title": "What's your budget?",
    "setup.step4_sub": "Set a total in IDR. You can adjust anytime.",
    "setup.custom_amount": "Custom amount (IDR)",
    "setup.step5_title": "How many guests?",
    "setup.step5_sub": "Rough estimate — refine later.",
    "setup.custom_estimate": "Custom estimate",
    "setup.step6_title": "Which ceremonies?",
    "setup.step6_sub": "Pick every event you're planning.",
    "setup.step7_title": "How will you get married?",
    "setup.step7_sub": "This decides which documents we prepare for you.",
    "setup.doc_track_kua": "KUA (Civil Registry)",
    "setup.doc_track_kua_hint": "Akad nikah is filed at KUA with a civil officer.",
    "setup.doc_track_gereja": "Gereja (Church)",
    "setup.doc_track_gereja_hint": "Nikah is held in church with a pastor.",
    "setup.doc_track_hint": "You can reopen setup later to switch. Existing documents are never deleted.",
    "setup.step8_title": "Your wedding vibe",
    "setup.step8_sub": "Pick up to 3 styles.",
    "setup.colors_q": "What colors do you imagine?",
    "setup.step9_title": "What have you already done?",
    "setup.step9_sub": "We'll skip these on your checklist.",
    "setup.step10_title": "Biggest challenges",
    "setup.step10_sub": "Pick up to 3. Weddly AI will tailor suggestions around them.",
    "setup.priorities_q": "What should Weddly help with?",
    "setup.step11_title": "Pick your Weddly theme",
    "setup.step11_sub": "Choose a palette that feels like your wedding. Switch anytime.",
    "setup.make_yours": "Make it yours",
    "setup.step12_badge": "Final Step ✨",
    "setup.step12_title": "Wedding Planning is Lighter When Done Together",
    "setup.step12_sub": "Don't stress alone! Invite {partner} now so you can tackle checklists, track savings, and answer Couple Talk together in real-time.",
    "setup.step12_sub_default": "Don't stress alone! Invite your partner now so you can tackle checklists, track savings, and answer Couple Talk together in real-time.",
    "setup.step12_b1_title": "Automatic Sync",
    "setup.step12_b1_desc": "Budget, checklist, and guest data always stay updated on each other's phones.",
    "setup.step12_b2_title": "Interactive Couple Talk",
    "setup.step12_b2_desc": "Answer pre-marital questions together directly from your own accounts.",
    "setup.step12_b3_title": "One Account for Both",
    "setup.step12_b3_desc": "Activate Premium once, accessible together with your partner.",
    "setup.step12_skip": "Maybe later, continue to Dashboard →",
    "setup.step12_btn_finish": "Finish & Go to Dashboard",
    "setup.step12_wa_btn": "Send Invite via WhatsApp",
    // Dashboard
    "dash.unlinked_partner_title": "Ready to plan together?",
    "dash.unlinked_partner_desc": "Connect your partner and prepare your special day together.",
    "dash.unlinked_partner_status": "Not connected",
    "dash.unlinked_partner_banner": "Ready to plan together? Connect your partner and prepare your special day together.",
    "dash.invite_partner_btn": "Invite partner",
    "dash.days_to_hday": "{n} days to the Big Day",
    // Checklist
    "check.filter_all": "All",
    // Budget
    "budget.section": "Finance · IDR",
    "budget.title": "Budget planner",
    "budget.add_btn": "Add expense",
    "budget.new": "New expense",
    "budget.edit": "Edit expense",
    "budget.updated": "Changes saved",
    "budget.total_budget_hint": "Overall target (set in Settings)",
    "budget.remaining_hint": "Total budget − Spent",
    "budget.set_budget_link": "Set budget →",
    "budget.item_name": "Item name",
    "budget.planned": "Planned",
    "budget.actual": "Actual",
    "budget.paid": "Paid",
    "budget.vendor_opt": "Vendor (optional)",
    "budget.save": "Save expense",
    "budget.added": "Expense added",
    "budget.name_required": "Item name required",
    "budget.total_budget": "Total budget",
    "budget.spent": "Spent",
    "budget.remaining": "Remaining",
    "budget.empty": "Let's set your wedding budget. Add your first expense.",
    // Wedding Savings
    "savings.section": "Wedding Savings",
    "savings.title": "Wedding Savings",
    "savings.subtitle": "Set aside money little by little and track it against your target.",
    "savings.total_label": "Total Collected",
    "savings.set_target": "Set Target",
    "savings.target_title": "Savings Target",
    "savings.target_label": "Target",
    "savings.target_hint": "Track your progress against the amount you aim to save for the wedding.",
    "savings.target_saved": "Savings target updated",
    "savings.target_error": "Failed to save savings target",
    "savings.no_target": "No target set yet. Set a target to see your progress.",
    "savings.remaining": "Still need",
    "savings.reached": "Target reached — thank you!",
    "savings.add_btn": "Add Savings",
    "savings.new": "New Savings Entry",
    "savings.edit": "Edit Savings Entry",
    "savings.label": "Saver",
    "savings.who": "Who is saving",
    "savings.who_ph": "Select saver",
    "savings.who_custom": "Enter manually",
    "savings.who_custom_ph": "Type saver name",
    "savings.who_required": "Please select who is saving",
    "savings.amount": "Amount",
    "savings.notes_opt": "Notes (optional)",
    "savings.empty": "No savings entries yet. Start setting aside your first savings!",
    "savings.added": "Savings entry added",
    "savings.updated": "Savings entry updated",
    "savings.deleted": "Savings entry deleted",
    "savings.load_error": "Failed to load savings",
    "savings.save_error": "Failed to save savings entry",
    "savings.delete_error": "Failed to delete savings entry",
    "savings.confirm_delete": "Delete this savings entry?",
    "budget.col_item": "Item",
    "budget.col_category": "Category",
    // Guests
    "guests.section": "Attendance",
    "guests.title": "Guest list",
    "guests.search": "Search guests…",
    "guests.add_btn": "Add guest",
    "guests.new": "New guest",
    "guests.name_required": "Name required",
    "guests.added": "Guest added",
    "guests.group": "Group",
    "guests.pax": "Pax",
    "guests.table": "Table",
    "guests.save": "Save guest",
    "guests.total": "Total",
    "guests.attending": "Attending",
    "guests.pending": "Pending",
    "guests.declined": "Declined",
    "guests.empty": "Your guest list is waiting. Add your first guest.",
    // Vendors
    "vendors.section": "Partners",
    "vendors.title": "Vendor hub",
    "vendors.all_categories": "All categories",
    "vendors.add_btn": "Add vendor",
    "vendors.new": "New vendor",
    "vendors.name_required": "Name required",
    "vendors.added": "Vendor added",
    "vendors.updated": "Vendor updated",
    "vendors.deleted": "Vendor removed",
    "vendors.contact_person": "Contact person",
    "vendors.price_idr": "Price (IDR)",
    "vendors.save": "Save vendor",
    "vendors.save_changes": "Save changes",
    "vendors.booking_status": "Booking status",
    "vendors.payment_status": "Payment status",
    "vendors.empty": "Start building your vendor team. Add your first vendor.",
    "vendors.details": "Vendor details",
    "vendors.click_hint": "Click a card to view details or edit",
    "vendors.confirm_delete": "Remove this vendor?",
    // Timeline
    "time.section": "Schedule",
    "time.title": "Timeline & rundown",
    "time.add_btn": "New event",
    "time.new": "New event",
    "time.title_field": "Title",
    "time.start": "Start",
    "time.end": "End",
    "time.location": "Location",
    "time.save": "Save event",
    "time.added": "Event added",
    "time.edit": "Edit event",
    "time.updated": "Event updated",
    "time.required": "Title and date required",
    "time.empty": "Your rundown starts here. Add your first event.",
    // AI
    "ai.title": "Weddly AI",
    "ai.placeholder": "Ask Weddly AI…",
    "ai.error": "Weddly AI is having trouble answering right now. Please try again.",
    "ai.intro": "Ask Weddly AI anything about your wedding — budget, rundowns, speeches, vendors.",
    "ai.clear": "Clear chat",
    "ai.clear_confirm": "Clear this conversation?",
    "ai.clear_yes": "Yes, clear",
    "ai.clear_no": "Cancel",
    // Settings
    "settings.section": "Preferences",
    "settings.title": "Settings",
    "settings.tab_profile": "Wedding profile",
    "settings.change_photo": "Change Photo",
    "settings.remove_photo": "Remove",
    "settings.photo_hint": "JPG/PNG/WebP, max 5 MB",
    "settings.photo_updated": "Profile photo updated",
    "settings.photo_removed": "Profile photo removed",
    "settings.photo_too_large": "Photo size max 5 MB",
    "settings.photo_error": "Failed to update profile photo",
    "settings.tab_theme": "Theme",
    "settings.tab_partners": "Partners",
    "settings.tab_language": "Language",
    "settings.saved": "Saved",
    "settings.save_changes": "Save changes",
    "settings.theme_note": "Your dashboard theme is shared with your partner.",
    "settings.theme_updated": "Theme updated",
    "settings.language_note": "Language is stored in your browser. Change anytime.",
    "settings.signed_in_as": "Signed in as",
    "settings.invite_hint": "Create your partner's account above and share the temporary password with them. They sign in with their own phone number.",
    "settings.add_partner_title": "Add partner account",
    "settings.add_partner_desc": "Enter your partner's phone number. Their account is created instantly and you'll get a temporary password to share with them.",
    "settings.partner_name_opt": "Partner name (optional)",
    "settings.partner_phone": "Phone number",
    "settings.create_account": "Create account",
    "settings.invite_created_title": "Partner account created!",
    "settings.temp_password_note": "Share this temporary password privately. Your partner will be asked to create their own password at first login.",
    "settings.partner_phone_required": "Phone number is required",
    "settings.invite_error": "Failed to create partner account",
    "settings.signout": "Sign out",
    "settings.field_p1_name": "Partner 1 name",
    "settings.field_p1_nick": "Partner 1 nickname",
    "settings.field_p2_name": "Partner 2 name",
    "settings.field_p2_nick": "Partner 2 nickname",
    "settings.field_date": "Wedding date",
    "settings.field_akad_time": "Ceremony Time",
    "settings.field_venue_ceremony": "Ceremony Venue",
    "settings.field_city": "City",
    "settings.field_budget": "Budget (IDR)",
    "settings.field_guests": "Guest estimate",
    // Admin
    // Hantaran & Mahar
    "nav.handover": "Hantaran & Mahar",
    "handover.section": "Logistics",
    "handover.title": "Hantaran & Mahar",
    "handover.subtitle": "Track handover items and mahar budget in one place.",
    "handover.tab_handover": "Handover",
    "handover.tab_mahar": "Mahar",
    "handover.add": "Add Item",
    "handover.add_category": "Add category",
    "handover.new_handover": "New handover item",
    "handover.new_mahar": "New mahar item",
    "handover.edit_item": "Edit item",
    "handover.k_total_items": "Total Items",
    "handover.k_in_process": "In Process",
    "handover.k_not_bought": "Not Bought Yet",
    "handover.k_sudah_dibeli": "Purchased / Done",
    "handover.k_total_estimasi": "Total Estimate",
    "handover.col_item": "Item",
    "handover.col_category": "Category",
    "handover.col_qty": "Qty",
    "handover.col_estimasi": "Estimate",
    "handover.col_status": "Status",
    "handover.col_actions": "Actions",
    "handover.f_item": "Item name",
    "handover.f_category": "Category",
    "handover.f_qty": "Quantity",
    "handover.f_estimasi": "Unit price (IDR)",
    "handover.f_status": "Status",
    "handover.f_vendor": "Vendor / source (optional)",
    "handover.f_notes": "Notes",
    "handover.status_dalam_proses": "In process",
    "handover.status_belum_dibeli": "Not bought yet",
    "handover.status_sudah_dibeli": "Purchased / Done",
    "handover.filter_all": "All",
    "handover.empty": "Nothing here yet. Add the first item to get started.",
    "handover.empty_filter": "No items in this category.",
    "handover.save": "Save",
    "handover.delete_confirm": "Delete this item?",
    "handover.new_category": "New category",
    "handover.category_added": "Category added",
  },
  id: {
    // Brand
    "brand.tagline_hero": "Dua hati,\nsatu ruang perencanaan.",
    "brand.tagline_sub": "Rencanakan setiap detail pernikahan Anda bersama — dari Akad hingga Resepsi — di satu tempat yang tenang dan indah.",
    // Login
    "auth.first_login_title": "Buat password Anda sendiri",
    "auth.first_login_desc": "Akun Anda dibuat oleh pasangan menggunakan password sementara. Demi keamanan, buat password Anda sendiri sekarang.",
    "auth.new_password": "Password baru",
    "auth.confirm_new_password": "Konfirmasi password baru",
    "auth.first_login_mismatch": "Konfirmasi password tidak cocok",
    "auth.password_too_short": "Password minimal 6 karakter",
    "auth.first_login_success": "Password berhasil dibuat! Silakan masuk dengan password baru Anda.",
    "login.welcome": "Selamat datang, calon pengantin.",
    "login.license_note": "Satu lisensi = satu workspace pernikahan untuk dua pasangan.",
    // Language
    "lang.label": "Bahasa",
    // Common
    "common.save": "Simpan",
    "common.saving": "Menyimpan…",
    "common.cancel": "Batal",
    "common.delete": "Hapus",
    "common.copy": "Salin",
    "common.copied": "Tersalin!",
    "common.name": "Nama",
    "common.category": "Kategori",
    "common.date": "Tanggal",
    "common.status": "Status",
    "common.notes": "Catatan",
    "common.phone": "Telepon",
    "common.email": "Email",
    // Nav
    "nav.dashboard": "Beranda",
    "nav.couple_talk": "Couple Talk",
    "nav.moodboard": "Wedding Moodboard",
    "nav.more": "Lainnya",
    "nav.checklist": "Checklist",
    "checklist.section": "Persiapan",
    "checklist.title": "Checklist",
    "nav.budget": "Anggaran",
    "nav.savings": "Tabungan",
    "nav.guests": "Tamu",
    "nav.vendors": "Vendor",
    "nav.timeline": "Jadwal",
    "nav.documents": "Dokumen",
    "nav.ai": "Weddly AI",
    "nav.settings": "Pengaturan",
    "nav.admin": "Admin",
    "nav.logout": "Keluar",
    "nav.group.main": "Menu Utama",
    "nav.group.planning": "Perencanaan",
    "nav.collapse": "Perkecil menu",
    "nav.expand": "Perbesar menu",
    // Documents
    "docs.section": "Persiapan",
    "docs.title": "Dokumen Kelengkapan Menikah",
    "docs.subtitle": "Kelengkapan berkas untuk KUA / gereja & pencatatan sipil — bisa simpan filenya juga.",
    "docs.stat_total": "Total dokumen",
    "docs.stat_done": "Sudah terkumpul",
    "docs.stat_uploaded": "File tersimpan",
    "docs.add_title": "Tambah dokumen sendiri",
    "docs.name_ph": "cth. Paspor",
    "docs.optional": "opsional",
    "docs.add_btn": "Tambah",
    "docs.hint": "Template dokumen sudah disiapkan otomatis. Centang yang sudah terkumpul, dan upload filenya supaya tidak perlu mencari lagi nanti.",
    "docs.mark_done": "Tandai sudah terkumpul",
    "docs.no_file_hint": "Opsional: upload file di sini agar mudah dicari kembali.",
    "docs.upload": "Upload",
    "docs.replace_file": "Ganti",
    "docs.remove_file": "Hapus file",
    "docs.empty": "Belum ada dokumen.",
    "docs.confirm_delete": "Hapus dokumen ini dari daftar?",
    "docs.file_too_large": "Ukuran file terlalu besar (maksimal 8 MB)",
    "docs.load_error": "Gagal memuat dokumen",
    "docs.name_required": "Nama dokumen wajib diisi",
    "docs.added": "Dokumen ditambahkan ✅",
    "docs.add_error": "Gagal menambah dokumen",
    "docs.update_error": "Gagal memperbarui dokumen",
    "docs.deleted": "Dokumen dihapus",
    "docs.delete_error": "Gagal menghapus dokumen",
    "docs.uploaded": "File berhasil diupload ✅",
    "docs.upload_error": "Gagal mengupload file",
    "docs.file_removed": "File dihapus",
    // Setup wizard
    "setup.step": "Langkah",
    "setup.of": "dari",
    "setup.saving": "Menyimpan…",
    "setup.draft_saved": "Draf tersimpan",
    "setup.back": "Kembali",
    "setup.next": "Lanjut",
    "setup.finish": "Buka Workspace Weddly",
    "setup.finishing": "Membuka…",
    "setup.ready_toast": "Rencana pernikahan Anda siap!",
    "setup.step1_title": "Siapa yang akan menikah?",
    "setup.step1_sub": "Beri tahu kami nama kedua mempelai. Anda bisa mengundang pasangan nanti.",
    "setup.p1_full": "Nama lengkap Mempelai 1",
    "setup.p1_nick": "Nama panggilan",
    "setup.p2_full": "Nama lengkap Mempelai 2",
    "setup.p2_nick": "Nama panggilan",
    "setup.step2_title": "Kapan hari besar Anda?",
    "setup.step2_sub": "Pilih tanggal — target juga boleh. Bisa diubah kapan saja.",
    "setup.date_confirmed": "Tanggal pasti",
    "setup.date_target": "Tanggal target",
    "setup.date_undecided": "Belum ditentukan",
    "setup.date_confirmed_hint": "Kami sudah tahu tanggalnya",
    "setup.date_target_hint": "Perkiraan tanggal",
    "setup.date_undecided_hint": "Lewati dulu",
    "setup.wedding_date": "Tanggal pernikahan",
    "setup.step3_title": "Di mana akan dilaksanakan?",
    "setup.step3_sub": "Negara dan kota membantu kami memberikan rekomendasi yang tepat.",
    "setup.country": "Negara",
    "setup.city": "Kota",
    "setup.venue_mode": "Lokasi acara",
    "setup.venue_same": "Satu venue",
    "setup.venue_diff": "Venue berbeda",
    "setup.venue_undecided": "Belum ditentukan",
    "setup.step4_title": "Berapa anggaran Anda?",
    "setup.step4_sub": "Tetapkan total dalam IDR. Bisa disesuaikan kapan saja.",
    "setup.custom_amount": "Nominal kustom (IDR)",
    "setup.step5_title": "Berapa jumlah tamu?",
    "setup.step5_sub": "Perkiraan kasar — bisa disesuaikan nanti.",
    "setup.custom_estimate": "Estimasi kustom",
    "setup.step6_title": "Prosesi mana saja?",
    "setup.step6_sub": "Pilih semua acara yang direncanakan.",
    "setup.step7_title": "Menikah lewat mana?",
    "setup.step7_sub": "Ini menentukan dokumen mana yang kami siapkan untuk Anda.",
    "setup.doc_track_kua": "KUA (Catatan Sitasi)",
    "setup.doc_track_kua_hint": "Akad nikah dicatatkan di KUA dengan penghulu.",
    "setup.doc_track_gereja": "Gereja",
    "setup.doc_track_gereja_hint": "Nikah dilangsungkan di gereja dengan pendeta.",
    "setup.doc_track_hint": "Anda bisa membuka setup lagi untuk mengganti. Dokumen yang sudah ada tidak akan dihapus.",
    "setup.step8_title": "Suasana pernikahan Anda",
    "setup.step8_sub": "Pilih hingga 3 gaya.",
    "setup.colors_q": "Warna apa yang Anda bayangkan?",
    "setup.step9_title": "Apa yang sudah beres?",
    "setup.step9_sub": "Kami akan melewati item ini di checklist.",
    "setup.step10_title": "Tantangan terbesar",
    "setup.step10_sub": "Pilih hingga 3. Weddly AI akan menyesuaikan sarannya.",
    "setup.priorities_q": "Weddly bantu urus apa saja?",
    "setup.step11_title": "Pilih tema Weddly Anda",
    "setup.step11_sub": "Pilih palet yang terasa seperti pernikahan Anda. Bisa diganti kapan saja.",
    "setup.make_yours": "Personalisasi",
    "setup.step12_badge": "Langkah Terakhir ✨",
    "setup.step12_title": "Persiapan Nikah Lebih Ringan Kalau Dikerjakan Berdua",
    "setup.step12_sub": "Jangan pusing sendiri! Undang {partner} sekarang supaya kalian bisa bareng-bareng nyicil checklist, pantau tabungan, dan isi Couple Talk secara real-time.",
    "setup.step12_sub_default": "Jangan pusing sendiri! Undang pasanganmu sekarang supaya kalian bisa bareng-bareng nyicil checklist, pantau tabungan, dan isi Couple Talk secara real-time.",
    "setup.step12_b1_title": "Sinkronisasi Otomatis",
    "setup.step12_b1_desc": "Data budget, checklist, dan tamu selalu terupdate di HP masing-masing.",
    "setup.step12_b2_title": "Couple Talk Interaktif",
    "setup.step12_b2_desc": "Saling jawab pertanyaan pranikah langsung dari akun masing-masing.",
    "setup.step12_b3_title": "Satu Akun untuk Berdua",
    "setup.step12_b3_desc": "Cukup satu kali aktifkan Premium, bisa diakses bersama pasangan.",
    "setup.step12_skip": "Nanti saja, lanjut ke Dashboard →",
    "setup.step12_btn_finish": "Selesai & Masuk ke Dashboard",
    "setup.step12_wa_btn": "Kirim Undangan via WhatsApp",
    // Dashboard
    "dash.unlinked_partner_title": "Siap planning bareng?",
    "dash.unlinked_partner_desc": "Hubungkan pasanganmu dan siapkan hari bahagia bersama.",
    "dash.unlinked_partner_status": "Belum terhubung",
    "dash.unlinked_partner_banner": "Siap planning bareng? Hubungkan pasanganmu dan siapkan hari bahagia bersama.",
    "dash.invite_partner_btn": "Undang pasangan",
    "dash.days_to_hday": "{n} hari menuju Hari-H",
    // Checklist
    "check.filter_all": "Semua",
    // Budget
    "budget.section": "Keuangan · IDR",
    "budget.title": "Perencanaan anggaran",
    "budget.add_btn": "Tambah pengeluaran",
    "budget.new": "Pengeluaran baru",
    "budget.edit": "Ubah pengeluaran",
    "budget.updated": "Perubahan disimpan",
    "budget.total_budget_hint": "Target keseluruhan (atur di Pengaturan)",
    "budget.remaining_hint": "Total Anggaran − Terpakai",
    "budget.set_budget_link": "Atur anggaran →",
    "budget.item_name": "Nama item",
    "budget.planned": "Rencana",
    "budget.actual": "Aktual",
    "budget.paid": "Dibayar",
    "budget.vendor_opt": "Vendor (opsional)",
    "budget.save": "Simpan pengeluaran",
    "budget.added": "Pengeluaran ditambahkan",
    "budget.name_required": "Nama item wajib diisi",
    "budget.total_budget": "Total anggaran",
    "budget.spent": "Terpakai",
    "budget.remaining": "Sisa",
    "budget.empty": "Ayo atur anggaran pernikahan. Tambahkan pengeluaran pertama.",
    // Tabungan Pernikahan
    "savings.section": "Tabungan",
    "savings.title": "Tabungan Pernikahan",
    "savings.subtitle": "Sisihkan dana sedikit demi sedikit dan pantau progresnya menuju target.",
    "savings.total_label": "Total Tabungan Terkumpul",
    "savings.set_target": "Atur Target",
    "savings.target_title": "Target Tabungan",
    "savings.target_label": "Target",
    "savings.target_hint": "Pantau progres tabungan terhadap nominal yang ingin kamu kumpulkan.",
    "savings.target_saved": "Target tabungan disimpan",
    "savings.target_error": "Gagal menyimpan target tabungan",
    "savings.no_target": "Belum ada target. Atur target dulu untuk melihat progres.",
    "savings.remaining": "Kurang lagi",
    "savings.reached": "Target tercapai — terima kasih!",
    "savings.add_btn": "Tambah Tabungan",
    "savings.new": "Catatan Tabungan Baru",
    "savings.edit": "Ubah Catatan Tabungan",
    "savings.label": "Penabung",
    "savings.who": "Siapa yang Nabung",
    "savings.who_ph": "Pilih penabung",
    "savings.who_custom": "Input sendiri",
    "savings.who_custom_ph": "Tulis nama penabung",
    "savings.who_required": "Pilih dulu siapa yang nabung",
    "savings.amount": "Nominal",
    "savings.notes_opt": "Catatan (opsional)",
    "savings.empty": "Belum ada catatan tabungan. Mulai sisihkan tabungan pertamamu!",
    "savings.added": "Setoran tabungan ditambahkan",
    "savings.updated": "Setoran tabungan diperbarui",
    "savings.deleted": "Setoran tabungan dihapus",
    "savings.load_error": "Gagal memuat tabungan",
    "savings.save_error": "Gagal menyimpan setoran tabungan",
    "savings.delete_error": "Gagal menghapus setoran tabungan",
    "savings.confirm_delete": "Hapus catatan tabungan ini?",
    "budget.col_item": "Item",
    "budget.col_category": "Kategori",
    // Guests
    "guests.section": "Kehadiran",
    "guests.title": "Daftar tamu",
    "guests.search": "Cari tamu…",
    "guests.add_btn": "Tambah tamu",
    "guests.new": "Tamu baru",
    "guests.name_required": "Nama wajib diisi",
    "guests.added": "Tamu ditambahkan",
    "guests.group": "Kelompok",
    "guests.pax": "Pax",
    "guests.table": "Meja",
    "guests.save": "Simpan tamu",
    "guests.total": "Total",
    "guests.attending": "Hadir",
    "guests.pending": "Menunggu",
    "guests.declined": "Tidak hadir",
    "guests.empty": "Daftar tamu Anda menanti. Tambahkan tamu pertama.",
    // Vendors
    "vendors.section": "Mitra",
    "vendors.title": "Hub vendor",
    "vendors.all_categories": "Semua kategori",
    "vendors.add_btn": "Tambah vendor",
    "vendors.new": "Vendor baru",
    "vendors.name_required": "Nama wajib diisi",
    "vendors.added": "Vendor ditambahkan",
    "vendors.updated": "Vendor diperbarui",
    "vendors.deleted": "Vendor dihapus",
    "vendors.contact_person": "Narahubung",
    "vendors.price_idr": "Harga (IDR)",
    "vendors.save": "Simpan vendor",
    "vendors.save_changes": "Simpan perubahan",
    "vendors.booking_status": "Status booking",
    "vendors.payment_status": "Status pembayaran",
    "vendors.empty": "Bangun tim vendor Anda. Tambahkan vendor pertama.",
    "vendors.details": "Detail vendor",
    "vendors.click_hint": "Klik kartu untuk melihat detail atau mengubah",
    "vendors.confirm_delete": "Hapus vendor ini?",
    // Timeline
    "time.section": "Jadwal",
    "time.title": "Timeline & rundown",
    "time.add_btn": "Acara baru",
    "time.new": "Acara baru",
    "time.title_field": "Judul",
    "time.start": "Mulai",
    "time.end": "Selesai",
    "time.location": "Lokasi",
    "time.save": "Simpan acara",
    "time.added": "Acara ditambahkan",
    "time.edit": "Ubah acara",
    "time.updated": "Acara diperbarui",
    "time.required": "Judul dan tanggal wajib diisi",
    "time.empty": "Rundown Anda dimulai di sini. Tambahkan acara pertama.",
    // AI
    "ai.title": "Weddly AI",
    "ai.placeholder": "Tanya Weddly AI…",
    "ai.error": "Weddly AI sedang kesulitan menjawab. Silakan coba lagi.",
    "ai.intro": "Tanyakan apa pun tentang pernikahan Anda — anggaran, rundown, sambutan, vendor.",
    "ai.clear": "Bersihkan chat",
    "ai.clear_confirm": "Bersihkan percakapan ini?",
    "ai.clear_yes": "Ya, bersihkan",
    "ai.clear_no": "Batal",
    // Settings
    "settings.section": "Preferensi",
    "settings.title": "Pengaturan",
    "settings.tab_profile": "Profil pernikahan",
    "settings.change_photo": "Ganti Foto",
    "settings.remove_photo": "Hapus",
    "settings.photo_hint": "JPG/PNG/WebP, maks 5 MB",
    "settings.photo_updated": "Foto profil diperbarui",
    "settings.photo_removed": "Foto profil dihapus",
    "settings.photo_too_large": "Ukuran foto maksimal 5 MB",
    "settings.photo_error": "Gagal memperbarui foto profil",
    "settings.tab_theme": "Tema",
    "settings.tab_partners": "Pasangan",
    "settings.tab_language": "Bahasa",
    "settings.saved": "Tersimpan",
    "settings.save_changes": "Simpan perubahan",
    "settings.theme_note": "Tema dashboard Anda dibagi dengan pasangan.",
    "settings.theme_updated": "Tema diperbarui",
    "settings.language_note": "Bahasa tersimpan di peramban Anda. Bisa diganti kapan saja.",
    "settings.signed_in_as": "Masuk sebagai",
    "settings.invite_hint": "Buat akun pasangan di atas lalu bagikan password sementara kepada mereka. Mereka masuk dengan nomor HP masing-masing.",
    "settings.add_partner_title": "Buat akun pasangan",
    "settings.add_partner_desc": "Masukkan nomor HP pasangan Anda. Akunnya langsung dibuat dan Anda mendapat password sementara untuk diberikan ke dia.",
    "settings.partner_name_opt": "Nama pasangan (opsional)",
    "settings.partner_phone": "Nomor HP",
    "settings.create_account": "Buat akun",
    "settings.invite_created_title": "Akun pasangan berhasil dibuat!",
    "settings.temp_password_note": "Sampaikan password sementara ini secara pribadi. Pasangan Anda akan diminta membuat password sendiri saat login pertama.",
    "settings.partner_phone_required": "Nomor HP wajib diisi",
    "settings.invite_error": "Gagal membuat akun pasangan",
    "settings.signout": "Keluar",
    "settings.field_p1_name": "Nama Mempelai 1",
    "settings.field_p1_nick": "Panggilan Mempelai 1",
    "settings.field_p2_name": "Nama Mempelai 2",
    "settings.field_p2_nick": "Panggilan Mempelai 2",
    "settings.field_date": "Tanggal pernikahan",
    "settings.field_akad_time": "Jam Mulai / Akad",
    "settings.field_venue_ceremony": "Lokasi / Gedung Akad",
    "settings.field_city": "Kota",
    "settings.field_budget": "Anggaran (IDR)",
    "settings.field_guests": "Estimasi tamu",
    // Admin
    // Hantaran & Mahar
    "nav.handover": "Hantaran & Mahar",
    "handover.section": "Logistik",
    "handover.title": "Hantaran & Mahar",
    "handover.subtitle": "Pantau daftar hantaran dan rencana mahar dalam satu tempat.",
    "handover.tab_handover": "Hantaran / Serahan",
    "handover.tab_mahar": "Mahar",
    "handover.add": "Tambah Item",
    "handover.add_category": "Tambah Kategori",
    "handover.new_handover": "Item Hantaran Baru",
    "handover.new_mahar": "Item Mahar Baru",
    "handover.edit_item": "Ubah item",
    "handover.k_total_items": "Total Item",
    "handover.k_in_process": "Dalam Proses",
    "handover.k_not_bought": "Belum Dibeli",
    "handover.k_sudah_dibeli": "Sudah Dibeli / Selesai",
    "handover.k_total_estimasi": "Total Estimasi",
    "handover.col_item": "Item",
    "handover.col_category": "Kategori",
    "handover.col_qty": "Jumlah",
    "handover.col_estimasi": "Estimasi",
    "handover.col_status": "Status",
    "handover.col_actions": "Aksi",
    "handover.f_item": "Nama item",
    "handover.f_category": "Kategori",
    "handover.f_qty": "Jumlah",
    "handover.f_estimasi": "Harga satuan (IDR)",
    "handover.f_status": "Status",
    "handover.f_vendor": "Vendor / sumber (opsional)",
    "handover.f_notes": "Catatan",
    "handover.status_dalam_proses": "Dalam proses",
    "handover.status_belum_dibeli": "Belum dibeli",
    "handover.status_sudah_dibeli": "Sudah dibeli / selesai",
    "handover.filter_all": "Semua",
    "handover.empty": "Belum ada apa-apa. Tambahkan item pertama untuk memulai.",
    "handover.empty_filter": "Tidak ada item pada kategori ini.",
    "handover.save": "Simpan",
    "handover.delete_confirm": "Hapus item ini?",
    "handover.new_category": "Kategori Baru",
    "handover.category_added": "Kategori ditambahkan",
  },
};
